export default "__VITE_ASSET__C9g2pB7j__"